// extracted by mini-css-extract-plugin
export var bold = "list-module--bold--9fe53";
export var item = "list-module--item--04ab1";
export var itemSmall = "list-module--itemSmall--d8d03";
export var link = "list-module--link--330b0";
export var list = "list-module--list--0debd";
export var small = "list-module--small--44857";